import settingsConfig from 'CampaignBuilder/settingsConfig'
import SettingsSchemaForm from 'Shared/components/Settings/SettingsSchemaForm'

export default function SettingsForm() {
  const act = useAct()
  const { settings, campaignType } = useSel((s) => s.campaign)
  const { mergeTags } = useSel((s) => s.campaignBuilder)

  const config = useMemo(() => {
    const base = settingsConfig[campaignType]
    if (!base) return base
    // Inject merge tags into html field configs
    return _.mapValues(base, (setting) => {
      if (setting.kind === 'html') {
        return { ...setting, mergeTags }
      }
      return setting
    })
  }, [campaignType, mergeTags])

  const onChange = (key, value) => {
    act.campaign.updateSetting(key, value)
  }

  return <SettingsSchemaForm onChange={onChange} settings={settings} config={config} />
}
